import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import HomeView from '@/views/home/HomeView.vue';
import { useStore } from 'vuex';
import { onBeforeMount } from 'vue';
import { computed } from '@vue/reactivity';
import { UserMenu } from '@/types';

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const store = useStore();

computed<UserMenu>(() => {
  return store.getters['userMenu/userMenu'];
});
onBeforeMount(async () => {
  await store.dispatch('userMenu/receive');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(HomeView))
}
}

})